export default __webpack_public_path__ + "ef288d5.png";